var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.288 4.16346C11.288 5.97963 9.8157 7.45192 7.99953 7.45192C6.18336 7.45192 4.71107 5.97963 4.71107 4.16346C4.71107 2.34729 6.18336 0.875 7.99953 0.875C9.8157 0.875 11.288 2.34729 11.288 4.16346Z",
    stroke: "#732130"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99953 15.125C11.257 15.125 13.1338 14.2848 14.0044 13.7439C14.4118 13.4909 14.6125 13.0249 14.5711 12.5422C14.5145 11.883 14.2842 11.2246 14.0497 10.7023C13.7417 10.0166 13.0289 9.64423 12.2773 9.64423H3.72181C2.97013 9.64423 2.25732 10.0166 1.94939 10.7023C1.71487 11.2245 1.48453 11.883 1.42794 12.5422C1.38651 13.0249 1.5873 13.4909 1.99469 13.7439C2.86529 14.2848 4.74205 15.125 7.99953 15.125Z",
    stroke: "#732130"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3d2c2bf17caaddad3bacd93892e8cb9b.svg";
export { ForwardRef as ReactComponent };